import Icon from 'snippets/icon/icon'
import Price from 'snippets/price/price'

function LinkCustom({ text, link, className = 'button-secondary', iconName, iconClass, iconViewBox, price, onClick }) {
  return (
    <a href={link} className={`flex items-center justify-center ${className}`} onClick={ onClick }>
      {iconName && <Icon name={iconName} className={iconClass} viewBox={iconViewBox} />}
      <span>{text}</span>
      {price && price !== 0 && <Price price={price} className="inline" />}
    </a>
  )
}

export default LinkCustom
